import Script from 'next/script';

export function YourAssetScript() {
  const src =
    process.env.NEXT_PUBLIC_YOUR_ASSET_URL?.trim() ||
    'https://cdn.skypack.dev/@yourasset/ya-finance-now';
  return <Script src={src} strategy='lazyOnload' type='module' />;
}
